import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Dispatch } from 'redux';
import urlencode from 'urlencode';
import { verifyEmail, dialogClear } from '../../../stores/auth/actionCreators';
import { invalidToken, isLoggedIn, resetPasswordSuccess } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import CenterContainer from '../../layout/CenterContainer';
import LoadingScreen from '../../navigation/LoadingScreen';
import VerifyEmailError from './VerifyEmailError';
import VerifyEmailSuccess from './VerifyEmailSuccess';

interface Props extends LocalizeContextProps, RouteComponentProps<{ id: string }> {
    isLoggedIn: boolean;
    success: boolean;
    invalidToken?: boolean;

    dialogClear: () => void;
    verifyEmailToken: (id: string, token: string) => void;
}

class VerifyEmailPage extends React.Component<Props> {
    public componentWillMount() {
        this.props.dialogClear();
        const { token } = urlencode.parse(this.props.location.search.substr(1), { charset: 'utf8' });
        this.props.verifyEmailToken(this.props.match.params.id, token);
    }

    public render() {
        const t = this.props.translate;

        if (this.props.invalidToken === undefined) {
            return (
                <LoadingScreen text={t('resetPassword.loading.loading') as string} />
            );
        }

        if (this.props.invalidToken) {
            return (
                <CenterContainer>
                    <VerifyEmailError />
                </CenterContainer>
            );
        }

        if (this.props.success) {
            return (
                <CenterContainer>
                    <VerifyEmailSuccess />
                </CenterContainer>
            );
        }

        return (
            <LoadingScreen />
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    invalidToken: invalidToken(state),
    isLoggedIn: isLoggedIn(state),
    success: resetPasswordSuccess(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    verifyEmailToken: (id: string, token: string) =>
        dispatch(verifyEmail(id, token)),
    dialogClear: () => dispatch(dialogClear()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(VerifyEmailPage)));
